export const config = _sys => {
  return {
    defaultCss: 'home-theme:base',
    defaultTheme: 'home-theme:default',
    defaultThemeHandler: '',
    model: {
      themename: {
        persister: {
          maxAge: Infinity
        }
      }
    }
  };
};